/* Shop listing, product page, classic sections and cart page behaviour.
   Same interactions as the recreation's shop.js; the cart is Shopify's (Ajax API: /cart/add.js, /cart.js). */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var routes = window.PlanteaRoutes || { cart: '/cart', cartAdd: '/cart/add.js', cartJson: '/cart.js' };

  /* ------------------------------------------------------------ first section sits under the fixed header */
  function headerOffset() {
    var header = document.getElementById('header') || $('header');
    var first = $('#sections > .page-section');
    if (!header || !first) return;
    var apply = function () {
      if (first.dataset.a2Pad !== '1' && parseFloat(getComputedStyle(first).paddingTop) > 0) return; // base.css already pads it
      first.dataset.a2Pad = '1';
      first.style.paddingTop = header.getBoundingClientRect().height + 'px';
    };
    apply();
    window.addEventListener('resize', apply);
    window.addEventListener('load', apply);
  }

  /* ------------------------------------------------------------ cart */
  function refreshCount() {
    return fetch(routes.cartJson, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { window.dispatchEvent(new CustomEvent('plantea:cart-change', { detail: { count: c.item_count } })); })
      .catch(function () { /* badge keeps its last value */ });
  }

  function addToCart(variantId, qty, btn) {
    if (!variantId || btn.classList.contains('cart-adding')) return;
    btn.classList.add('cart-adding');
    btn.setAttribute('aria-busy', 'true');
    fetch(routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
    }).then(function (r) {
      btn.classList.remove('cart-adding');
      btn.removeAttribute('aria-busy');
      if (!r.ok) return; // e.g. not enough stock: nothing is added, the button returns to its idle state
      btn.classList.add('cart-added');
      setTimeout(function () { btn.classList.remove('cart-added'); }, 1500);
      return refreshCount();
    }).catch(function () {
      btn.classList.remove('cart-adding');
      btn.removeAttribute('aria-busy');
    });
  }

  /* ------------------------------------------------------------ product list */
  function productList() {
    // entrance: items fade/slide in once their cover image has loaded
    $$('.product-list-item').forEach(function (item) {
      var img = $('.grid-image-cover', item);
      var done = function () { item.classList.add('is-loaded'); };
      if (!img || img.complete) done(); else { img.addEventListener('load', done); img.addEventListener('error', done); setTimeout(done, 4000); }
      var hov = $('.grid-image-hover', item);
      if (hov) { var mark = function () { hov.classList.add('loaded'); }; if (hov.complete && hov.naturalWidth) mark(); else hov.addEventListener('load', mark); }
    });
    var list = $('.product-list-section .product-list');
    if (!list) return;

    // mobile category dropdown navigates
    var catSel = $('#product-categories-filter-dropdown-select', list);
    if (catSel) catSel.addEventListener('change', function () { location.href = catSel.value; });

    // variant dropdowns: price follows the selection, placeholder option disappears
    $$('.product-list-item .variant-select', list).forEach(function (sel) {
      sel.addEventListener('change', function () {
        var item = sel.closest('.product-list-item');
        var wrap = sel.closest('.variant-select-wrapper');
        var ph = $('.unselected-option-value', sel);
        if (sel.value && ph) ph.remove();
        sel.classList.toggle('has-value', !!sel.value);
        var opt = sel.options[sel.selectedIndex];
        wrap.setAttribute('data-selected-value', opt ? opt.text : '');
        var icon = $('.variant-select-icon', wrap); if (icon) icon.classList.toggle('show-icon-placeholder', !sel.value);
        var priceEl = $('.product-list-item-price', item);
        if (priceEl) priceEl.textContent = (opt && opt.dataset.price) || priceEl.dataset.basePrice;
      });
    });

    // add to cart from the grid
    list.addEventListener('click', function (e) {
      var btn = e.target.closest('.sqs-add-to-cart-button');
      if (!btn || btn.disabled) return;
      var item = btn.closest('.product-list-item');
      var sel = $('.variant-select', item);
      if (sel && !sel.value) { sel.focus(); return; } // a size must be chosen first
      addToCart(sel ? sel.value : btn.dataset.variantId, 1, btn);
    });
  }

  /* ------------------------------------------------------------ product detail page */
  function productDetail() {
    var root = $('.product-detail');
    if (!root) return;

    // --- gallery slideshow
    var slidesWrap = $('.product-gallery-slides', root);
    var slides = $$('.product-gallery-slides-item', root);
    var indicator = $('.product-gallery-current-slide-indicator', root);
    var cur = 0;
    function go(n, dir) {
      if (slides.length < 2) return;
      n = (n + slides.length) % slides.length;
      if (n === cur) return;
      var prev = slides[cur], next = slides[n];
      slides.forEach(function (s) { s.classList.remove('leaving', 'to-left', 'to-right', 'from-left', 'from-right'); });
      prev.classList.remove('selected'); prev.classList.add('leaving', dir > 0 ? 'to-left' : 'to-right');
      prev.setAttribute('aria-hidden', 'true'); prev.tabIndex = -1; prev.removeAttribute('role');
      next.classList.add('selected', dir > 0 ? 'from-right' : 'from-left');
      next.removeAttribute('aria-hidden'); next.tabIndex = 0; next.setAttribute('role', 'link');
      var img = $('img', next); if (img && img.loading === 'lazy') img.loading = 'eager';
      setTimeout(function () { prev.classList.remove('leaving', 'to-left', 'to-right'); }, 520);
      cur = n;
      if (indicator) indicator.textContent = (cur + 1) + ' / ' + slides.length;
    }
    var prevBtn = $('.product-gallery-prev', root), nextBtn = $('.product-gallery-next', root);
    if (prevBtn) prevBtn.addEventListener('click', function (e) { e.stopPropagation(); go(cur - 1, -1); });
    if (nextBtn) nextBtn.addEventListener('click', function (e) { e.stopPropagation(); go(cur + 1, 1); });
    // touch swipe (mobile)
    var sx = null, swiped = false;
    if (slidesWrap) {
      slidesWrap.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      slidesWrap.addEventListener('touchend', function (e) {
        if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; sx = null;
        if (Math.abs(dx) > 40) { swiped = true; go(cur + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1); setTimeout(function () { swiped = false; }, 50); }
      });
    }

    // --- lightbox (click on a slide)
    var lb = $('.gallery-lightbox', root);
    var lbItems = lb ? $$('.gallery-lightbox-item', lb) : [];
    var lbCur = 0, lbOpen = false;
    if (lb) document.body.appendChild(lb.parentNode); // fixed overlay must have no transformed ancestor (full viewport)
    var lbSrc = window.innerWidth < 768 ? 'srcMobile' : 'src';
    function lbShow(n) {
      lbCur = (n + lbItems.length) % lbItems.length;
      lbItems.forEach(function (f, i) {
        f.classList.toggle('is-active', i === lbCur);
        var img = $('img', f);
        if (Math.abs(i - lbCur) <= 1 || i === 0 || i === lbItems.length - 1) { if (img && !img.getAttribute('src') && img.dataset.src) img.src = img.dataset[lbSrc] || img.dataset.src; }
      });
    }
    function lbOpenAt(n) {
      if (!lb || lbOpen) return;
      lbOpen = true;
      lb.hidden = false;
      document.documentElement.classList.add('a2-lightbox-open');
      lbShow(n);
      void lb.offsetHeight; // start the fade from opacity 0
      lb.classList.add('is-open');
      var c = $('.gallery-lightbox-close-btn', lb); if (c) c.focus();
    }
    function lbClose() {
      if (!lbOpen) return;
      lbOpen = false;
      lb.classList.remove('is-open');
      document.documentElement.classList.remove('a2-lightbox-open');
      setTimeout(function () { if (!lbOpen) lb.hidden = true; }, 300);
      var s = slides[cur]; if (s) s.focus({ preventScroll: true });
    }
    slides.forEach(function (s, i) {
      s.addEventListener('click', function () { if (!swiped) lbOpenAt(i); });
      s.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); lbOpenAt(i); } });
    });
    if (lb) {
      $('.gallery-lightbox-close-btn', lb).addEventListener('click', lbClose);
      $('[data-previous] button', lb).addEventListener('click', function () { lbShow(lbCur - 1); });
      $('[data-next] button', lb).addEventListener('click', function () { lbShow(lbCur + 1); });
      $('.gallery-lightbox-background', lb).addEventListener('click', lbClose);
      document.addEventListener('keydown', function (e) {
        if (!lbOpen) return;
        if (e.key === 'Escape') lbClose();
        else if (e.key === 'ArrowLeft') lbShow(lbCur - 1);
        else if (e.key === 'ArrowRight') lbShow(lbCur + 1);
      });
    }

    // --- variants (pill radios) → price + the form's variant id
    var form = $('form.product-form', root);
    var idInput = form ? form.elements.id : null;
    var priceEl = $('.product-price-value', root);
    var radios = $$('.radio-button-input', root);
    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        if (idInput) idInput.value = r.value;
        if (priceEl && r.dataset.price) priceEl.textContent = r.dataset.price;
        try { history.replaceState(history.state, '', location.pathname + '?variant=' + r.value); } catch (e) { /* ignore */ }
      });
    });
    // the visible pill is a span[role=button]; keyboard activation selects its radio
    $$('.variant-radiobtn-wrapper .radio-label', root).forEach(function (lab) {
      lab.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        var inp = lab.parentNode.querySelector('input');
        if (inp && !inp.disabled) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    });

    // --- quantity stepper
    var qty = $('.product-quantity-input input', root);
    var dec = $('.decrease-button', root), inc = $('.increase-button', root);
    function setQ(n) {
      n = Math.max(1, Math.min(9999, parseInt(n, 10) || 1));
      qty.value = n;
      dec.disabled = n <= 1;
    }
    if (qty) {
      dec.addEventListener('click', function () { setQ(Number(qty.value) - 1); });
      inc.addEventListener('click', function () { setQ(Number(qty.value) + 1); });
      qty.addEventListener('change', function () { setQ(qty.value); });
      qty.addEventListener('input', function () { dec.disabled = (parseInt(qty.value, 10) || 1) <= 1; });
    }

    // --- add to cart (the form posts normally without JavaScript)
    var btn = $('.product-add-to-cart .sqs-add-to-cart-button', root);
    if (form && btn) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.disabled) return;
      if (!idInput.value) { var first = $('.variant-radiobtn-wrapper .radio-label', root); if (first) first.focus(); return; } // a size must be chosen first
      addToCart(idInput.value, qty ? parseInt(qty.value, 10) || 1 : 1, btn);
    });
  }

  /* ------------------------------------------------------------ classic sections: accordion + gallery-block lightbox */
  function accordions() {
    $$('.accordion-item__click-target').forEach(function (b) {
      var dd = document.getElementById(b.getAttribute('aria-controls'));
      if (!dd) return;
      b.addEventListener('click', function () {
        var open = b.getAttribute('aria-expanded') === 'true';
        b.setAttribute('aria-expanded', String(!open));
        clearTimeout(dd._a2t);
        if (open) {
          dd.style.height = dd.scrollHeight + 'px';
          void dd.offsetHeight; // commit the start height, then animate to 0
          dd.style.height = '0px';
          dd._a2t = setTimeout(function () { dd.classList.remove('accordion-item__dropdown--open'); }, 320);
        } else {
          dd.classList.add('accordion-item__dropdown--open');
          dd.style.height = '0px';
          void dd.offsetHeight;
          dd.style.height = dd.scrollHeight + 'px';
          // after the .3s height transition the panel follows its content (timer also covers no-transition cases)
          dd._a2t = setTimeout(function () { if (b.getAttribute('aria-expanded') === 'true') dd.style.height = 'auto'; }, 320);
        }
      });
    });
  }

  function galleryBlockLightbox() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('.js-gallery-lightbox-opener');
      if (!a) return;
      e.preventDefault();
      var anchors = $$('.js-gallery-lightbox-opener', a.closest('.sqs-gallery'));
      var idx = anchors.indexOf(a);
      var box = document.createElement('div');
      box.className = 'a2-sqs-lightbox';
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      box.innerHTML = '<div class="a2-sqs-lightbox-overlay"></div>' +
        '<a class="a2-sqs-lightbox-close" role="button" tabindex="0" aria-label="Close"></a>' +
        '<a class="a2-sqs-lightbox-previous" role="button" tabindex="0" aria-label="Previous"></a>' +
        '<a class="a2-sqs-lightbox-next" role="button" tabindex="0" aria-label="Next"></a>' +
        anchors.map(function () { return '<div class="a2-sqs-lightbox-slide"><div class="a2-sqs-lightbox-padder"><img alt=""></div></div>'; }).join('');
      document.body.appendChild(box);
      document.documentElement.classList.add('a2-lightbox-open');
      var slidesEls = $$('.a2-sqs-lightbox-slide', box);
      slidesEls.forEach(function (s, i) { var src = $('img', anchors[i]); var img = $('img', s); img.alt = src ? src.alt : ''; img.src = anchors[i].getAttribute('href'); });
      var show = function (n) { idx = (n + slidesEls.length) % slidesEls.length; slidesEls.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); }); };
      var close = function () { box.remove(); document.documentElement.classList.remove('a2-lightbox-open'); document.removeEventListener('keydown', key); a.focus(); };
      var key = function (ev) { if (ev.key === 'Escape') close(); else if (ev.key === 'ArrowLeft') show(idx - 1); else if (ev.key === 'ArrowRight') show(idx + 1); };
      $('.a2-sqs-lightbox-close', box).addEventListener('click', close);
      $('.a2-sqs-lightbox-previous', box).addEventListener('click', function () { show(idx - 1); });
      $('.a2-sqs-lightbox-next', box).addEventListener('click', function () { show(idx + 1); });
      $('.a2-sqs-lightbox-overlay', box).addEventListener('click', close);
      document.addEventListener('keydown', key);
      show(idx);
      $('.a2-sqs-lightbox-close', box).focus();
    });
  }

  /* ------------------------------------------------------------ cart page (rendered by Liquid) */
  function cartPage() {
    var form = document.getElementById('cart-form');
    if (!form) return;
    form.addEventListener('change', function (e) {
      if (e.target.closest('.cart-row-qty input')) form.submit(); // posts updates[] and reloads the cart
    });
    form.addEventListener('click', function (e) {
      var b = e.target.closest('.cart-row-remove');
      if (b) location.href = b.dataset.removeUrl;
    });
  }

  function init() {
    headerOffset();
    productList();
    productDetail();
    accordions();
    galleryBlockLightbox();
    cartPage();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
